module.exports = __webpack_public_path__ + "img/container2CheckBox.54d53cd1.svg";